export default __webpack_public_path__ + "static/media/photo7.f773879d.jpg";